import { useMemo } from 'react';
import { type GetNeighborhoodsQuery, useGetNeighborhoodsQuery } from 'types/generated/client';

export type Neighborhood = GetNeighborhoodsQuery['neighborhoods'][number];

/** Every active neighborhood, not scoped to the viewer's city or location. */
export function useNeighborhoods() {
  const { data } = useGetNeighborhoodsQuery();

  return useMemo(() => {
    const neighborhoods = data?.neighborhoods ?? [];
    const pickNeighborhoods = (ids: string[]) =>
      neighborhoods.filter((row) => ids.includes(row.id));
    return { neighborhoods, pickNeighborhoods };
  }, [data]);
}
